const maintenance = {
    state: {
        active: 0
    },
    actions: {

    },
    mutations: {
        SET_PUBLIC_ACTIVE(state,value){
            state.active = value
        }
    },
    getters: {
        getAh(state) {
            return state.ah
        }
    },
    namespaced: true
}
export default maintenance